import React, {Component} from "react";
import {request} from "../../../api-client";
import Form from "../Form";
import localization from '../../../config/localization'
import {makeImageUrlWithSize} from "../../../layouts/Home/HomeElements/utils";

export default class extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      user: null,
    };
  }

  componentDidMount = () => {
    this.requestUser();
  };

  userId = () => this.props.match.params.id;

  requestUser = () =>
    request.user.get(this.userId()).then(user => {
      this.setState({ user, showForm: true });
    });

  requestUpdate = data => {
    return request.user.update({
      userId: this.userId(),
      name: data.name,
      email: data.email,
      description: data.description,
      imageFile: data.image.file,
      roleId: data.roleId,
      language: data.language,
      selectedCreator: data.selectedCreator,
      subscribedToPitches: data.subscribedToPitches,
    });
  }


  onImageChange = image => this.setState({ image });

  render = () => {
    if (!this.state.showForm) {
      return null;
    }
    const { name, email, description, role, image, language, contentCreator } = this.state.user;

    return (
      <Form
        {...this.props}
        name={name}
        email={email}
        description={description}
        roleId={role && role.id}
        selectedCreator={contentCreator ? {value: contentCreator.id, label: contentCreator.name} : null}
        language={language}
        image={image && makeImageUrlWithSize(this.state.user, 'md')}
        submitRequest={this.requestUpdate}
        formTitle={localization.get('user.update_user')}
        type={"update"}
      />
    );
  };
}
